// extracted by mini-css-extract-plugin
export var wordContainer = "_ko-0";